import { fmtTL, fmtDate, fmtCreator } from "../../lib/format";

// Geçmiş değerler: her kayıtta önceki toplamlar (limit / risk / kalan), vade, açıklama, kaydeden
export default function LimitRiskHistory({ card, userLabels }) {
  const hist = card.history || [];
  return (
    <div className="rounded-md border border-slate-200 bg-slate-50/80 p-3" data-testid={`lr-history-${card.id}`}>
      <div className="text-[10px] uppercase tracking-widest text-slate-500 font-semibold mb-1">Geçmiş değerler ({hist.length})</div>
      <table className="w-full text-xs">
        <thead><tr className="text-[10px] uppercase text-slate-500"><th className="text-left py-1 pr-3">Tarih</th><th className="text-right py-1 pr-3">Toplam Limit</th><th className="text-right py-1 pr-3">Toplam Risk</th><th className="text-right py-1 pr-3">Kalan</th><th className="text-left py-1 pr-3">Vade</th><th className="text-left py-1 pr-3">İpotek</th><th className="text-left py-1 pr-3">Açıklama</th><th className="text-left py-1">Kaydeden</th></tr></thead>
        <tbody>
          {hist.map((h, i) => {
            const l = h.totals?.limit?.total || 0, r = h.totals?.risk?.total || 0;
            return (
              <tr key={`${h.saved_at}-${i}`} className="border-t border-slate-200" data-testid={`lr-history-row-${card.id}-${i}`}>
                <td className="py-1 pr-3">{h.report_date ? fmtDate(h.report_date) : "—"}</td>
                <td className="py-1 pr-3 text-right font-mono">{fmtTL(l)}</td>
                <td className="py-1 pr-3 text-right font-mono">{fmtTL(r)}</td>
                <td className="py-1 pr-3 text-right font-mono">{fmtTL(l - r)}</td>
                <td className="py-1 pr-3">{h.due_date ? fmtDate(h.due_date) : "—"}</td>
                <td className="py-1 pr-3">{h.mortgages?.length ? `${h.mortgages.length} demirbaş` : "—"}</td>
                <td className="py-1 pr-3 text-slate-600">{h.description || "—"}</td>
                <td className="py-1 text-slate-500">{fmtCreator(h.saved_by, h.saved_at, userLabels)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
